import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Repo } from '@repos/repo.service';

export interface Email {
	email: string;
}

const COLLECTION_NAME = 'registeredInterest';

@Injectable({
	providedIn: 'root',
})
export class RegisteredInterestService extends Repo<Email, {}> {
	GetCollectionPath(): string {
		return COLLECTION_NAME;
	}

	constructor(private firestore: AngularFirestore) {
		super(firestore);
	}
}
